import { fetchAllAllowedClients } from 'Services/ProductManagement/Features/AllowedClient/allowedClientSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useEffect } from 'react'

interface UseAllowedClientsProps {
  excludeManagerClient?: boolean
}

function useAllowedClients({ excludeManagerClient = false }: UseAllowedClientsProps = {}) {
  const dispatch = useAppDispatch()

  const { allAllowedClients, allAllowedClientsLoading } = useTypedSelector(
    state => state.allowedClient
  )

  useEffect(() => {
    if (excludeManagerClient) {
      dispatch(fetchAllAllowedClients({ exclude_manager_client: excludeManagerClient }))
    } else {
      dispatch(fetchAllAllowedClients({}))
    }
  }, [])

  return {
    allAllowedClients,
    allAllowedClientsLoading
  }
}

export default useAllowedClients
